module.exports = __webpack_public_path__ + "static/media/notshowchart.d7eaa75a.svg";